/* eslint-disable */
import {UnaryMethodDefinition} from '@improbable-eng/grpc-web/dist/typings/service';
import {
  Device,
  CustomerSession,
  RequestConfig,
  deviceFromJSON,
  deviceToJSON,
} from '../../../protos/shared/shared';
import {BrowserHeaders} from 'browser-headers';
import {grpc} from '@improbable-eng/grpc-web';
import {CheckoutSession} from '../../../protos/checkout/checkout_session';
import {
  RecurringPaymentMethod,
  BankAccount,
} from '../../../protos/payments/v1/payment_info';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'payments.v1';

export interface GetRecurringPaymentMethodsRequest {
  childShopId: number;
  /** @deprecated */
  checkoutSession?: CheckoutSession | undefined;
  device: Device;
  session: CustomerSession | undefined;
}

export interface GetRecurringPaymentMethodsResponse {
  paymentInformation: RecurringPaymentMethod[];
}

export interface UpdateRecurringPaymentMethodRequest {
  childShopId: number;
  /** @deprecated */
  checkoutSession?: CheckoutSession | undefined;
  paymentMethodId: string;
  type?: {$case: 'refundBankAccount'; refundBankAccount: BankAccount};
  device: Device;
  session: CustomerSession | undefined;
}

export interface UpdateRecurringPaymentMethodResponse {
  paymentMethod: RecurringPaymentMethod | undefined;
}

/** @deprecated */
export interface DeleteRecurringPaymentRequest {
  childShopId: number;
  /** @deprecated */
  checkoutSession?: CheckoutSession | undefined;
  paymentMethodId: string;
  device: Device;
  session: CustomerSession | undefined;
}

export interface DeleteRecurringPaymentResponse {}

export interface CreateRecurringPaymentMethodRequest {
  childShopId: number;
  device: Device;
  /** @deprecated */
  checkoutSession?: CheckoutSession | undefined;
  orderId: number;
  type?: {$case: 'refundBankAccount'; refundBankAccount: BankAccount};
  session: CustomerSession | undefined;
}

export interface CreateRecurringPaymentMethodResponse {
  paymentMethod: RecurringPaymentMethod | undefined;
}

export interface SetRefundBankAccountRequest {
  config: RequestConfig | undefined;
  /** @deprecated */
  checkoutSession?: CheckoutSession | undefined;
  bankAccount: BankAccount | undefined;
}

export interface SetRefundBankAccountResponse {
  paymentMethods: RecurringPaymentMethod[];
}

export interface CreateGiftCardRefundRequest {
  config: RequestConfig | undefined;
  /** @deprecated */
  checkoutSession?: CheckoutSession | undefined;
  /** Depending on the `type`, the code will be the secret or serial number of the gift card */
  code: string;
  /** Either secret or serial number */
  type: CreateGiftCardRefundRequest_GiftCardType;
  /** Personal information */
  firstName: string;
  lastName: string;
  street: string;
  postalCode: string;
  city: string;
  /** Freeform text for the country as filled in by the user in any format. */
  country: string;
  email: string;
  /** Refund information */
  iban: string;
}

export enum CreateGiftCardRefundRequest_GiftCardType {
  GIFT_CARD_TYPE_INVALID = 0,
  GIFT_CARD_TYPE_SECRET_NUMBER = 1,
  GIFT_CARD_TYPE_SERIAL_NUMBER = 2,
  UNRECOGNIZED = -1,
}

export function createGiftCardRefundRequest_GiftCardTypeFromJSON(
  object: any,
): CreateGiftCardRefundRequest_GiftCardType {
  switch (object) {
    case 0:
    case 'GIFT_CARD_TYPE_INVALID':
      return CreateGiftCardRefundRequest_GiftCardType.GIFT_CARD_TYPE_INVALID;
    case 1:
    case 'GIFT_CARD_TYPE_SECRET_NUMBER':
      return CreateGiftCardRefundRequest_GiftCardType.GIFT_CARD_TYPE_SECRET_NUMBER;
    case 2:
    case 'GIFT_CARD_TYPE_SERIAL_NUMBER':
      return CreateGiftCardRefundRequest_GiftCardType.GIFT_CARD_TYPE_SERIAL_NUMBER;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CreateGiftCardRefundRequest_GiftCardType.UNRECOGNIZED;
  }
}

export function createGiftCardRefundRequest_GiftCardTypeToJSON(
  object: CreateGiftCardRefundRequest_GiftCardType,
): string {
  switch (object) {
    case CreateGiftCardRefundRequest_GiftCardType.GIFT_CARD_TYPE_INVALID:
      return 'GIFT_CARD_TYPE_INVALID';
    case CreateGiftCardRefundRequest_GiftCardType.GIFT_CARD_TYPE_SECRET_NUMBER:
      return 'GIFT_CARD_TYPE_SECRET_NUMBER';
    case CreateGiftCardRefundRequest_GiftCardType.GIFT_CARD_TYPE_SERIAL_NUMBER:
      return 'GIFT_CARD_TYPE_SERIAL_NUMBER';
    default:
      return 'UNKNOWN';
  }
}

export interface CreateGiftCardRefundResponse {
  /** e.g.: "Thank you for your request" */
  headline: string;
  /** e.g.: "The amount will be credited to your account." */
  text: string;
}

const baseGetRecurringPaymentMethodsRequest: object = {
  childShopId: 0,
  device: 0,
};

export const GetRecurringPaymentMethodsRequest = {
  encode(
    message: GetRecurringPaymentMethodsRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.childShopId !== 0) {
      writer.uint32(8).int32(message.childShopId);
    }
    if (message.checkoutSession !== undefined) {
      CheckoutSession.encode(
        message.checkoutSession,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.device !== 0) {
      writer.uint32(24).int32(message.device);
    }
    if (message.session !== undefined) {
      CustomerSession.encode(
        message.session,
        writer.uint32(34).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): GetRecurringPaymentMethodsRequest {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseGetRecurringPaymentMethodsRequest,
    } as GetRecurringPaymentMethodsRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.childShopId = reader.int32();
          break;
        case 2:
          message.checkoutSession = CheckoutSession.decode(
            reader,
            reader.uint32(),
          );
          break;
        case 3:
          message.device = reader.int32() as any;
          break;
        case 4:
          message.session = CustomerSession.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GetRecurringPaymentMethodsRequest {
    const message = {
      ...baseGetRecurringPaymentMethodsRequest,
    } as GetRecurringPaymentMethodsRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = Number(object.childShopId);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromJSON(
        object.checkoutSession,
      );
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = deviceFromJSON(object.device);
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromJSON(object.session);
    }
    return message;
  },

  toJSON(message: GetRecurringPaymentMethodsRequest): unknown {
    const obj: any = {};
    message.childShopId !== undefined &&
      (obj.childShopId = message.childShopId);
    message.checkoutSession !== undefined &&
      (obj.checkoutSession = message.checkoutSession
        ? CheckoutSession.toJSON(message.checkoutSession)
        : undefined);
    message.device !== undefined && (obj.device = deviceToJSON(message.device));
    message.session !== undefined &&
      (obj.session = message.session
        ? CustomerSession.toJSON(message.session)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<GetRecurringPaymentMethodsRequest>,
  ): GetRecurringPaymentMethodsRequest {
    const message = {
      ...baseGetRecurringPaymentMethodsRequest,
    } as GetRecurringPaymentMethodsRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = object.childShopId;
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromPartial(
        object.checkoutSession,
      );
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = object.device;
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromPartial(object.session);
    }
    return message;
  },
};

const baseGetRecurringPaymentMethodsResponse: object = {};

export const GetRecurringPaymentMethodsResponse = {
  encode(
    message: GetRecurringPaymentMethodsResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    for (const v of message.paymentInformation) {
      RecurringPaymentMethod.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): GetRecurringPaymentMethodsResponse {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseGetRecurringPaymentMethodsResponse,
    } as GetRecurringPaymentMethodsResponse;
    message.paymentInformation = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.paymentInformation.push(
            RecurringPaymentMethod.decode(reader, reader.uint32()),
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): GetRecurringPaymentMethodsResponse {
    const message = {
      ...baseGetRecurringPaymentMethodsResponse,
    } as GetRecurringPaymentMethodsResponse;
    message.paymentInformation = [];
    if (
      object.paymentInformation !== undefined &&
      object.paymentInformation !== null
    ) {
      for (const e of object.paymentInformation) {
        message.paymentInformation.push(RecurringPaymentMethod.fromJSON(e));
      }
    }
    return message;
  },

  toJSON(message: GetRecurringPaymentMethodsResponse): unknown {
    const obj: any = {};
    if (message.paymentInformation) {
      obj.paymentInformation = message.paymentInformation.map(e =>
        e ? RecurringPaymentMethod.toJSON(e) : undefined,
      );
    } else {
      obj.paymentInformation = [];
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<GetRecurringPaymentMethodsResponse>,
  ): GetRecurringPaymentMethodsResponse {
    const message = {
      ...baseGetRecurringPaymentMethodsResponse,
    } as GetRecurringPaymentMethodsResponse;
    message.paymentInformation = [];
    if (
      object.paymentInformation !== undefined &&
      object.paymentInformation !== null
    ) {
      for (const e of object.paymentInformation) {
        message.paymentInformation.push(RecurringPaymentMethod.fromPartial(e));
      }
    }
    return message;
  },
};

const baseUpdateRecurringPaymentMethodRequest: object = {
  childShopId: 0,
  paymentMethodId: '',
  device: 0,
};

export const UpdateRecurringPaymentMethodRequest = {
  encode(
    message: UpdateRecurringPaymentMethodRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.childShopId !== 0) {
      writer.uint32(8).int32(message.childShopId);
    }
    if (message.checkoutSession !== undefined) {
      CheckoutSession.encode(
        message.checkoutSession,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.paymentMethodId !== '') {
      writer.uint32(26).string(message.paymentMethodId);
    }
    if (message.type?.$case === 'refundBankAccount') {
      BankAccount.encode(
        message.type.refundBankAccount,
        writer.uint32(34).fork(),
      ).ldelim();
    }
    if (message.device !== 0) {
      writer.uint32(40).int32(message.device);
    }
    if (message.session !== undefined) {
      CustomerSession.encode(
        message.session,
        writer.uint32(50).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): UpdateRecurringPaymentMethodRequest {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseUpdateRecurringPaymentMethodRequest,
    } as UpdateRecurringPaymentMethodRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.childShopId = reader.int32();
          break;
        case 2:
          message.checkoutSession = CheckoutSession.decode(
            reader,
            reader.uint32(),
          );
          break;
        case 3:
          message.paymentMethodId = reader.string();
          break;
        case 4:
          message.type = {
            $case: 'refundBankAccount',
            refundBankAccount: BankAccount.decode(reader, reader.uint32()),
          };
          break;
        case 5:
          message.device = reader.int32() as any;
          break;
        case 6:
          message.session = CustomerSession.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UpdateRecurringPaymentMethodRequest {
    const message = {
      ...baseUpdateRecurringPaymentMethodRequest,
    } as UpdateRecurringPaymentMethodRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = Number(object.childShopId);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromJSON(
        object.checkoutSession,
      );
    }
    if (
      object.paymentMethodId !== undefined &&
      object.paymentMethodId !== null
    ) {
      message.paymentMethodId = String(object.paymentMethodId);
    }
    if (
      object.refundBankAccount !== undefined &&
      object.refundBankAccount !== null
    ) {
      message.type = {
        $case: 'refundBankAccount',
        refundBankAccount: BankAccount.fromJSON(object.refundBankAccount),
      };
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = deviceFromJSON(object.device);
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromJSON(object.session);
    }
    return message;
  },

  toJSON(message: UpdateRecurringPaymentMethodRequest): unknown {
    const obj: any = {};
    message.childShopId !== undefined &&
      (obj.childShopId = message.childShopId);
    message.checkoutSession !== undefined &&
      (obj.checkoutSession = message.checkoutSession
        ? CheckoutSession.toJSON(message.checkoutSession)
        : undefined);
    message.paymentMethodId !== undefined &&
      (obj.paymentMethodId = message.paymentMethodId);
    message.type?.$case === 'refundBankAccount' &&
      (obj.refundBankAccount = message.type?.refundBankAccount
        ? BankAccount.toJSON(message.type?.refundBankAccount)
        : undefined);
    message.device !== undefined && (obj.device = deviceToJSON(message.device));
    message.session !== undefined &&
      (obj.session = message.session
        ? CustomerSession.toJSON(message.session)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<UpdateRecurringPaymentMethodRequest>,
  ): UpdateRecurringPaymentMethodRequest {
    const message = {
      ...baseUpdateRecurringPaymentMethodRequest,
    } as UpdateRecurringPaymentMethodRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = object.childShopId;
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromPartial(
        object.checkoutSession,
      );
    }
    if (
      object.paymentMethodId !== undefined &&
      object.paymentMethodId !== null
    ) {
      message.paymentMethodId = object.paymentMethodId;
    }
    if (
      object.type?.$case === 'refundBankAccount' &&
      object.type?.refundBankAccount !== undefined &&
      object.type?.refundBankAccount !== null
    ) {
      message.type = {
        $case: 'refundBankAccount',
        refundBankAccount: BankAccount.fromPartial(
          object.type.refundBankAccount,
        ),
      };
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = object.device;
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromPartial(object.session);
    }
    return message;
  },
};

const baseUpdateRecurringPaymentMethodResponse: object = {};

export const UpdateRecurringPaymentMethodResponse = {
  encode(
    message: UpdateRecurringPaymentMethodResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.paymentMethod !== undefined) {
      RecurringPaymentMethod.encode(
        message.paymentMethod,
        writer.uint32(10).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): UpdateRecurringPaymentMethodResponse {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseUpdateRecurringPaymentMethodResponse,
    } as UpdateRecurringPaymentMethodResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.paymentMethod = RecurringPaymentMethod.decode(
            reader,
            reader.uint32(),
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UpdateRecurringPaymentMethodResponse {
    const message = {
      ...baseUpdateRecurringPaymentMethodResponse,
    } as UpdateRecurringPaymentMethodResponse;
    if (object.paymentMethod !== undefined && object.paymentMethod !== null) {
      message.paymentMethod = RecurringPaymentMethod.fromJSON(
        object.paymentMethod,
      );
    }
    return message;
  },

  toJSON(message: UpdateRecurringPaymentMethodResponse): unknown {
    const obj: any = {};
    message.paymentMethod !== undefined &&
      (obj.paymentMethod = message.paymentMethod
        ? RecurringPaymentMethod.toJSON(message.paymentMethod)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<UpdateRecurringPaymentMethodResponse>,
  ): UpdateRecurringPaymentMethodResponse {
    const message = {
      ...baseUpdateRecurringPaymentMethodResponse,
    } as UpdateRecurringPaymentMethodResponse;
    if (object.paymentMethod !== undefined && object.paymentMethod !== null) {
      message.paymentMethod = RecurringPaymentMethod.fromPartial(
        object.paymentMethod,
      );
    }
    return message;
  },
};

const baseDeleteRecurringPaymentRequest: object = {
  childShopId: 0,
  paymentMethodId: '',
  device: 0,
};

export const DeleteRecurringPaymentRequest = {
  encode(
    message: DeleteRecurringPaymentRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.childShopId !== 0) {
      writer.uint32(8).int32(message.childShopId);
    }
    if (message.checkoutSession !== undefined) {
      CheckoutSession.encode(
        message.checkoutSession,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.paymentMethodId !== '') {
      writer.uint32(26).string(message.paymentMethodId);
    }
    if (message.device !== 0) {
      writer.uint32(32).int32(message.device);
    }
    if (message.session !== undefined) {
      CustomerSession.encode(
        message.session,
        writer.uint32(42).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): DeleteRecurringPaymentRequest {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseDeleteRecurringPaymentRequest,
    } as DeleteRecurringPaymentRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.childShopId = reader.int32();
          break;
        case 2:
          message.checkoutSession = CheckoutSession.decode(
            reader,
            reader.uint32(),
          );
          break;
        case 3:
          message.paymentMethodId = reader.string();
          break;
        case 4:
          message.device = reader.int32() as any;
          break;
        case 5:
          message.session = CustomerSession.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): DeleteRecurringPaymentRequest {
    const message = {
      ...baseDeleteRecurringPaymentRequest,
    } as DeleteRecurringPaymentRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = Number(object.childShopId);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromJSON(
        object.checkoutSession,
      );
    }
    if (
      object.paymentMethodId !== undefined &&
      object.paymentMethodId !== null
    ) {
      message.paymentMethodId = String(object.paymentMethodId);
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = deviceFromJSON(object.device);
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromJSON(object.session);
    }
    return message;
  },

  toJSON(message: DeleteRecurringPaymentRequest): unknown {
    const obj: any = {};
    message.childShopId !== undefined &&
      (obj.childShopId = message.childShopId);
    message.checkoutSession !== undefined &&
      (obj.checkoutSession = message.checkoutSession
        ? CheckoutSession.toJSON(message.checkoutSession)
        : undefined);
    message.paymentMethodId !== undefined &&
      (obj.paymentMethodId = message.paymentMethodId);
    message.device !== undefined && (obj.device = deviceToJSON(message.device));
    message.session !== undefined &&
      (obj.session = message.session
        ? CustomerSession.toJSON(message.session)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<DeleteRecurringPaymentRequest>,
  ): DeleteRecurringPaymentRequest {
    const message = {
      ...baseDeleteRecurringPaymentRequest,
    } as DeleteRecurringPaymentRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = object.childShopId;
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromPartial(
        object.checkoutSession,
      );
    }
    if (
      object.paymentMethodId !== undefined &&
      object.paymentMethodId !== null
    ) {
      message.paymentMethodId = object.paymentMethodId;
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = object.device;
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromPartial(object.session);
    }
    return message;
  },
};

const baseDeleteRecurringPaymentResponse: object = {};

export const DeleteRecurringPaymentResponse = {
  encode(
    _: DeleteRecurringPaymentResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): DeleteRecurringPaymentResponse {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseDeleteRecurringPaymentResponse,
    } as DeleteRecurringPaymentResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): DeleteRecurringPaymentResponse {
    const message = {
      ...baseDeleteRecurringPaymentResponse,
    } as DeleteRecurringPaymentResponse;
    return message;
  },

  toJSON(_: DeleteRecurringPaymentResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial(
    _: DeepPartial<DeleteRecurringPaymentResponse>,
  ): DeleteRecurringPaymentResponse {
    const message = {
      ...baseDeleteRecurringPaymentResponse,
    } as DeleteRecurringPaymentResponse;
    return message;
  },
};

const baseCreateRecurringPaymentMethodRequest: object = {
  childShopId: 0,
  device: 0,
  orderId: 0,
};

export const CreateRecurringPaymentMethodRequest = {
  encode(
    message: CreateRecurringPaymentMethodRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.childShopId !== 0) {
      writer.uint32(8).int32(message.childShopId);
    }
    if (message.device !== 0) {
      writer.uint32(16).int32(message.device);
    }
    if (message.checkoutSession !== undefined) {
      CheckoutSession.encode(
        message.checkoutSession,
        writer.uint32(26).fork(),
      ).ldelim();
    }
    if (message.orderId !== 0) {
      writer.uint32(32).int32(message.orderId);
    }
    if (message.type?.$case === 'refundBankAccount') {
      BankAccount.encode(
        message.type.refundBankAccount,
        writer.uint32(42).fork(),
      ).ldelim();
    }
    if (message.session !== undefined) {
      CustomerSession.encode(
        message.session,
        writer.uint32(50).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): CreateRecurringPaymentMethodRequest {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseCreateRecurringPaymentMethodRequest,
    } as CreateRecurringPaymentMethodRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.childShopId = reader.int32();
          break;
        case 2:
          message.device = reader.int32() as any;
          break;
        case 3:
          message.checkoutSession = CheckoutSession.decode(
            reader,
            reader.uint32(),
          );
          break;
        case 4:
          message.orderId = reader.int32();
          break;
        case 5:
          message.type = {
            $case: 'refundBankAccount',
            refundBankAccount: BankAccount.decode(reader, reader.uint32()),
          };
          break;
        case 6:
          message.session = CustomerSession.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CreateRecurringPaymentMethodRequest {
    const message = {
      ...baseCreateRecurringPaymentMethodRequest,
    } as CreateRecurringPaymentMethodRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = Number(object.childShopId);
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = deviceFromJSON(object.device);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromJSON(
        object.checkoutSession,
      );
    }
    if (object.orderId !== undefined && object.orderId !== null) {
      message.orderId = Number(object.orderId);
    }
    if (
      object.refundBankAccount !== undefined &&
      object.refundBankAccount !== null
    ) {
      message.type = {
        $case: 'refundBankAccount',
        refundBankAccount: BankAccount.fromJSON(object.refundBankAccount),
      };
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromJSON(object.session);
    }
    return message;
  },

  toJSON(message: CreateRecurringPaymentMethodRequest): unknown {
    const obj: any = {};
    message.childShopId !== undefined &&
      (obj.childShopId = message.childShopId);
    message.device !== undefined && (obj.device = deviceToJSON(message.device));
    message.checkoutSession !== undefined &&
      (obj.checkoutSession = message.checkoutSession
        ? CheckoutSession.toJSON(message.checkoutSession)
        : undefined);
    message.orderId !== undefined && (obj.orderId = message.orderId);
    message.type?.$case === 'refundBankAccount' &&
      (obj.refundBankAccount = message.type?.refundBankAccount
        ? BankAccount.toJSON(message.type?.refundBankAccount)
        : undefined);
    message.session !== undefined &&
      (obj.session = message.session
        ? CustomerSession.toJSON(message.session)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<CreateRecurringPaymentMethodRequest>,
  ): CreateRecurringPaymentMethodRequest {
    const message = {
      ...baseCreateRecurringPaymentMethodRequest,
    } as CreateRecurringPaymentMethodRequest;
    if (object.childShopId !== undefined && object.childShopId !== null) {
      message.childShopId = object.childShopId;
    }
    if (object.device !== undefined && object.device !== null) {
      message.device = object.device;
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromPartial(
        object.checkoutSession,
      );
    }
    if (object.orderId !== undefined && object.orderId !== null) {
      message.orderId = object.orderId;
    }
    if (
      object.type?.$case === 'refundBankAccount' &&
      object.type?.refundBankAccount !== undefined &&
      object.type?.refundBankAccount !== null
    ) {
      message.type = {
        $case: 'refundBankAccount',
        refundBankAccount: BankAccount.fromPartial(
          object.type.refundBankAccount,
        ),
      };
    }
    if (object.session !== undefined && object.session !== null) {
      message.session = CustomerSession.fromPartial(object.session);
    }
    return message;
  },
};

const baseCreateRecurringPaymentMethodResponse: object = {};

export const CreateRecurringPaymentMethodResponse = {
  encode(
    message: CreateRecurringPaymentMethodResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.paymentMethod !== undefined) {
      RecurringPaymentMethod.encode(
        message.paymentMethod,
        writer.uint32(10).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): CreateRecurringPaymentMethodResponse {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseCreateRecurringPaymentMethodResponse,
    } as CreateRecurringPaymentMethodResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.paymentMethod = RecurringPaymentMethod.decode(
            reader,
            reader.uint32(),
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CreateRecurringPaymentMethodResponse {
    const message = {
      ...baseCreateRecurringPaymentMethodResponse,
    } as CreateRecurringPaymentMethodResponse;
    if (object.paymentMethod !== undefined && object.paymentMethod !== null) {
      message.paymentMethod = RecurringPaymentMethod.fromJSON(
        object.paymentMethod,
      );
    }
    return message;
  },

  toJSON(message: CreateRecurringPaymentMethodResponse): unknown {
    const obj: any = {};
    message.paymentMethod !== undefined &&
      (obj.paymentMethod = message.paymentMethod
        ? RecurringPaymentMethod.toJSON(message.paymentMethod)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<CreateRecurringPaymentMethodResponse>,
  ): CreateRecurringPaymentMethodResponse {
    const message = {
      ...baseCreateRecurringPaymentMethodResponse,
    } as CreateRecurringPaymentMethodResponse;
    if (object.paymentMethod !== undefined && object.paymentMethod !== null) {
      message.paymentMethod = RecurringPaymentMethod.fromPartial(
        object.paymentMethod,
      );
    }
    return message;
  },
};

const baseSetRefundBankAccountRequest: object = {};

export const SetRefundBankAccountRequest = {
  encode(
    message: SetRefundBankAccountRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.config !== undefined) {
      RequestConfig.encode(message.config, writer.uint32(10).fork()).ldelim();
    }
    if (message.checkoutSession !== undefined) {
      CheckoutSession.encode(
        message.checkoutSession,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.bankAccount !== undefined) {
      BankAccount.encode(
        message.bankAccount,
        writer.uint32(26).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): SetRefundBankAccountRequest {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseSetRefundBankAccountRequest,
    } as SetRefundBankAccountRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.config = RequestConfig.decode(reader, reader.uint32());
          break;
        case 2:
          message.checkoutSession = CheckoutSession.decode(
            reader,
            reader.uint32(),
          );
          break;
        case 3:
          message.bankAccount = BankAccount.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): SetRefundBankAccountRequest {
    const message = {
      ...baseSetRefundBankAccountRequest,
    } as SetRefundBankAccountRequest;
    if (object.config !== undefined && object.config !== null) {
      message.config = RequestConfig.fromJSON(object.config);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromJSON(
        object.checkoutSession,
      );
    }
    if (object.bankAccount !== undefined && object.bankAccount !== null) {
      message.bankAccount = BankAccount.fromJSON(object.bankAccount);
    }
    return message;
  },

  toJSON(message: SetRefundBankAccountRequest): unknown {
    const obj: any = {};
    message.config !== undefined &&
      (obj.config = message.config
        ? RequestConfig.toJSON(message.config)
        : undefined);
    message.checkoutSession !== undefined &&
      (obj.checkoutSession = message.checkoutSession
        ? CheckoutSession.toJSON(message.checkoutSession)
        : undefined);
    message.bankAccount !== undefined &&
      (obj.bankAccount = message.bankAccount
        ? BankAccount.toJSON(message.bankAccount)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<SetRefundBankAccountRequest>,
  ): SetRefundBankAccountRequest {
    const message = {
      ...baseSetRefundBankAccountRequest,
    } as SetRefundBankAccountRequest;
    if (object.config !== undefined && object.config !== null) {
      message.config = RequestConfig.fromPartial(object.config);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromPartial(
        object.checkoutSession,
      );
    }
    if (object.bankAccount !== undefined && object.bankAccount !== null) {
      message.bankAccount = BankAccount.fromPartial(object.bankAccount);
    }
    return message;
  },
};

const baseSetRefundBankAccountResponse: object = {};

export const SetRefundBankAccountResponse = {
  encode(
    message: SetRefundBankAccountResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    for (const v of message.paymentMethods) {
      RecurringPaymentMethod.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): SetRefundBankAccountResponse {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseSetRefundBankAccountResponse,
    } as SetRefundBankAccountResponse;
    message.paymentMethods = [];
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.paymentMethods.push(
            RecurringPaymentMethod.decode(reader, reader.uint32()),
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): SetRefundBankAccountResponse {
    const message = {
      ...baseSetRefundBankAccountResponse,
    } as SetRefundBankAccountResponse;
    message.paymentMethods = [];
    if (object.paymentMethods !== undefined && object.paymentMethods !== null) {
      for (const e of object.paymentMethods) {
        message.paymentMethods.push(RecurringPaymentMethod.fromJSON(e));
      }
    }
    return message;
  },

  toJSON(message: SetRefundBankAccountResponse): unknown {
    const obj: any = {};
    if (message.paymentMethods) {
      obj.paymentMethods = message.paymentMethods.map(e =>
        e ? RecurringPaymentMethod.toJSON(e) : undefined,
      );
    } else {
      obj.paymentMethods = [];
    }
    return obj;
  },

  fromPartial(
    object: DeepPartial<SetRefundBankAccountResponse>,
  ): SetRefundBankAccountResponse {
    const message = {
      ...baseSetRefundBankAccountResponse,
    } as SetRefundBankAccountResponse;
    message.paymentMethods = [];
    if (object.paymentMethods !== undefined && object.paymentMethods !== null) {
      for (const e of object.paymentMethods) {
        message.paymentMethods.push(RecurringPaymentMethod.fromPartial(e));
      }
    }
    return message;
  },
};

const baseCreateGiftCardRefundRequest: object = {
  code: '',
  type: 0,
  firstName: '',
  lastName: '',
  street: '',
  postalCode: '',
  city: '',
  country: '',
  email: '',
  iban: '',
};

export const CreateGiftCardRefundRequest = {
  encode(
    message: CreateGiftCardRefundRequest,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.config !== undefined) {
      RequestConfig.encode(message.config, writer.uint32(10).fork()).ldelim();
    }
    if (message.checkoutSession !== undefined) {
      CheckoutSession.encode(
        message.checkoutSession,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    if (message.code !== '') {
      writer.uint32(26).string(message.code);
    }
    if (message.type !== 0) {
      writer.uint32(32).int32(message.type);
    }
    if (message.firstName !== '') {
      writer.uint32(42).string(message.firstName);
    }
    if (message.lastName !== '') {
      writer.uint32(50).string(message.lastName);
    }
    if (message.street !== '') {
      writer.uint32(58).string(message.street);
    }
    if (message.postalCode !== '') {
      writer.uint32(66).string(message.postalCode);
    }
    if (message.city !== '') {
      writer.uint32(74).string(message.city);
    }
    if (message.country !== '') {
      writer.uint32(82).string(message.country);
    }
    if (message.email !== '') {
      writer.uint32(90).string(message.email);
    }
    if (message.iban !== '') {
      writer.uint32(98).string(message.iban);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): CreateGiftCardRefundRequest {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseCreateGiftCardRefundRequest,
    } as CreateGiftCardRefundRequest;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.config = RequestConfig.decode(reader, reader.uint32());
          break;
        case 2:
          message.checkoutSession = CheckoutSession.decode(
            reader,
            reader.uint32(),
          );
          break;
        case 3:
          message.code = reader.string();
          break;
        case 4:
          message.type = reader.int32() as any;
          break;
        case 5:
          message.firstName = reader.string();
          break;
        case 6:
          message.lastName = reader.string();
          break;
        case 7:
          message.street = reader.string();
          break;
        case 8:
          message.postalCode = reader.string();
          break;
        case 9:
          message.city = reader.string();
          break;
        case 10:
          message.country = reader.string();
          break;
        case 11:
          message.email = reader.string();
          break;
        case 12:
          message.iban = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CreateGiftCardRefundRequest {
    const message = {
      ...baseCreateGiftCardRefundRequest,
    } as CreateGiftCardRefundRequest;
    if (object.config !== undefined && object.config !== null) {
      message.config = RequestConfig.fromJSON(object.config);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromJSON(
        object.checkoutSession,
      );
    }
    if (object.code !== undefined && object.code !== null) {
      message.code = String(object.code);
    }
    if (object.type !== undefined && object.type !== null) {
      message.type = createGiftCardRefundRequest_GiftCardTypeFromJSON(
        object.type,
      );
    }
    if (object.firstName !== undefined && object.firstName !== null) {
      message.firstName = String(object.firstName);
    }
    if (object.lastName !== undefined && object.lastName !== null) {
      message.lastName = String(object.lastName);
    }
    if (object.street !== undefined && object.street !== null) {
      message.street = String(object.street);
    }
    if (object.postalCode !== undefined && object.postalCode !== null) {
      message.postalCode = String(object.postalCode);
    }
    if (object.city !== undefined && object.city !== null) {
      message.city = String(object.city);
    }
    if (object.country !== undefined && object.country !== null) {
      message.country = String(object.country);
    }
    if (object.email !== undefined && object.email !== null) {
      message.email = String(object.email);
    }
    if (object.iban !== undefined && object.iban !== null) {
      message.iban = String(object.iban);
    }
    return message;
  },

  toJSON(message: CreateGiftCardRefundRequest): unknown {
    const obj: any = {};
    message.config !== undefined &&
      (obj.config = message.config
        ? RequestConfig.toJSON(message.config)
        : undefined);
    message.checkoutSession !== undefined &&
      (obj.checkoutSession = message.checkoutSession
        ? CheckoutSession.toJSON(message.checkoutSession)
        : undefined);
    message.code !== undefined && (obj.code = message.code);
    message.type !== undefined &&
      (obj.type = createGiftCardRefundRequest_GiftCardTypeToJSON(message.type));
    message.firstName !== undefined && (obj.firstName = message.firstName);
    message.lastName !== undefined && (obj.lastName = message.lastName);
    message.street !== undefined && (obj.street = message.street);
    message.postalCode !== undefined && (obj.postalCode = message.postalCode);
    message.city !== undefined && (obj.city = message.city);
    message.country !== undefined && (obj.country = message.country);
    message.email !== undefined && (obj.email = message.email);
    message.iban !== undefined && (obj.iban = message.iban);
    return obj;
  },

  fromPartial(
    object: DeepPartial<CreateGiftCardRefundRequest>,
  ): CreateGiftCardRefundRequest {
    const message = {
      ...baseCreateGiftCardRefundRequest,
    } as CreateGiftCardRefundRequest;
    if (object.config !== undefined && object.config !== null) {
      message.config = RequestConfig.fromPartial(object.config);
    }
    if (
      object.checkoutSession !== undefined &&
      object.checkoutSession !== null
    ) {
      message.checkoutSession = CheckoutSession.fromPartial(
        object.checkoutSession,
      );
    }
    if (object.code !== undefined && object.code !== null) {
      message.code = object.code;
    }
    if (object.type !== undefined && object.type !== null) {
      message.type = object.type;
    }
    if (object.firstName !== undefined && object.firstName !== null) {
      message.firstName = object.firstName;
    }
    if (object.lastName !== undefined && object.lastName !== null) {
      message.lastName = object.lastName;
    }
    if (object.street !== undefined && object.street !== null) {
      message.street = object.street;
    }
    if (object.postalCode !== undefined && object.postalCode !== null) {
      message.postalCode = object.postalCode;
    }
    if (object.city !== undefined && object.city !== null) {
      message.city = object.city;
    }
    if (object.country !== undefined && object.country !== null) {
      message.country = object.country;
    }
    if (object.email !== undefined && object.email !== null) {
      message.email = object.email;
    }
    if (object.iban !== undefined && object.iban !== null) {
      message.iban = object.iban;
    }
    return message;
  },
};

const baseCreateGiftCardRefundResponse: object = {headline: '', text: ''};

export const CreateGiftCardRefundResponse = {
  encode(
    message: CreateGiftCardRefundResponse,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.headline !== '') {
      writer.uint32(10).string(message.headline);
    }
    if (message.text !== '') {
      writer.uint32(18).string(message.text);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): CreateGiftCardRefundResponse {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {
      ...baseCreateGiftCardRefundResponse,
    } as CreateGiftCardRefundResponse;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.headline = reader.string();
          break;
        case 2:
          message.text = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CreateGiftCardRefundResponse {
    const message = {
      ...baseCreateGiftCardRefundResponse,
    } as CreateGiftCardRefundResponse;
    if (object.headline !== undefined && object.headline !== null) {
      message.headline = String(object.headline);
    }
    if (object.text !== undefined && object.text !== null) {
      message.text = String(object.text);
    }
    return message;
  },

  toJSON(message: CreateGiftCardRefundResponse): unknown {
    const obj: any = {};
    message.headline !== undefined && (obj.headline = message.headline);
    message.text !== undefined && (obj.text = message.text);
    return obj;
  },

  fromPartial(
    object: DeepPartial<CreateGiftCardRefundResponse>,
  ): CreateGiftCardRefundResponse {
    const message = {
      ...baseCreateGiftCardRefundResponse,
    } as CreateGiftCardRefundResponse;
    if (object.headline !== undefined && object.headline !== null) {
      message.headline = object.headline;
    }
    if (object.text !== undefined && object.text !== null) {
      message.text = object.text;
    }
    return message;
  },
};

export interface PaymentsService {
  /** getRecurringPaymentMethods returns the list of recurring payment methods for the customer */
  getRecurringPaymentMethods(
    request: DeepPartial<GetRecurringPaymentMethodsRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetRecurringPaymentMethodsResponse>;
  /**
   * updateRecurringPaymentInfo updates the recurring payment information. This also applies only for COD enabled countries
   *
   * In case the endpoint returns an `codes.InvalidArgument`, the error details contain a `google.rpc.BadRequest` message describing the fields that failed.
   */
  updateRecurringPaymentInfo(
    request: DeepPartial<UpdateRecurringPaymentMethodRequest>,
    metadata?: grpc.Metadata,
  ): Promise<UpdateRecurringPaymentMethodResponse>;
  /** deleteRecurringPayment deletes a given payment method */
  deleteRecurringPayment(
    request: DeepPartial<DeleteRecurringPaymentRequest>,
    metadata?: grpc.Metadata,
  ): Promise<DeleteRecurringPaymentResponse>;
  /**
   * createRecurringPaymentMethod creates a new recurring payment method (currently limited to bank accounts)
   * (via a specific order, but the data is stored on the customer as a whole)
   * If the customer already has a bank account as a "recurring payment method" (even if just for COD reimbursements), use `updateRecurringPaymentInfo` instead
   */
  createRecurringPaymentMethod(
    request: DeepPartial<CreateRecurringPaymentMethodRequest>,
    metadata?: grpc.Metadata,
  ): Promise<CreateRecurringPaymentMethodResponse>;
  /** setRefundBankAccount sets (creates or updates) the customer's bank account used for COD refunds */
  setRefundBankAccount(
    request: DeepPartial<SetRefundBankAccountRequest>,
    metadata?: grpc.Metadata,
  ): Promise<SetRefundBankAccountResponse>;
  /** create a gift card refund request. */
  createGiftCardRefund(
    request: DeepPartial<CreateGiftCardRefundRequest>,
    metadata?: grpc.Metadata,
  ): Promise<CreateGiftCardRefundResponse>;
}

export class PaymentsServiceClientImpl implements PaymentsService {
  private readonly rpc: Rpc;

  constructor(rpc: Rpc) {
    this.rpc = rpc;
  }

  getRecurringPaymentMethods(
    request: DeepPartial<GetRecurringPaymentMethodsRequest>,
    metadata?: grpc.Metadata,
  ): Promise<GetRecurringPaymentMethodsResponse> {
    return this.rpc.unary(
      PaymentsServicegetRecurringPaymentMethodsDesc,
      GetRecurringPaymentMethodsRequest.fromPartial(request),
      metadata,
    );
  }

  updateRecurringPaymentInfo(
    request: DeepPartial<UpdateRecurringPaymentMethodRequest>,
    metadata?: grpc.Metadata,
  ): Promise<UpdateRecurringPaymentMethodResponse> {
    return this.rpc.unary(
      PaymentsServiceupdateRecurringPaymentInfoDesc,
      UpdateRecurringPaymentMethodRequest.fromPartial(request),
      metadata,
    );
  }

  deleteRecurringPayment(
    request: DeepPartial<DeleteRecurringPaymentRequest>,
    metadata?: grpc.Metadata,
  ): Promise<DeleteRecurringPaymentResponse> {
    return this.rpc.unary(
      PaymentsServicedeleteRecurringPaymentDesc,
      DeleteRecurringPaymentRequest.fromPartial(request),
      metadata,
    );
  }

  createRecurringPaymentMethod(
    request: DeepPartial<CreateRecurringPaymentMethodRequest>,
    metadata?: grpc.Metadata,
  ): Promise<CreateRecurringPaymentMethodResponse> {
    return this.rpc.unary(
      PaymentsServicecreateRecurringPaymentMethodDesc,
      CreateRecurringPaymentMethodRequest.fromPartial(request),
      metadata,
    );
  }

  setRefundBankAccount(
    request: DeepPartial<SetRefundBankAccountRequest>,
    metadata?: grpc.Metadata,
  ): Promise<SetRefundBankAccountResponse> {
    return this.rpc.unary(
      PaymentsServicesetRefundBankAccountDesc,
      SetRefundBankAccountRequest.fromPartial(request),
      metadata,
    );
  }

  createGiftCardRefund(
    request: DeepPartial<CreateGiftCardRefundRequest>,
    metadata?: grpc.Metadata,
  ): Promise<CreateGiftCardRefundResponse> {
    return this.rpc.unary(
      PaymentsServicecreateGiftCardRefundDesc,
      CreateGiftCardRefundRequest.fromPartial(request),
      metadata,
    );
  }
}

export const PaymentsServiceDesc = {
  serviceName: 'payments.v1.PaymentsService',
};

export const PaymentsServicegetRecurringPaymentMethodsDesc: UnaryMethodDefinitionish =
  {
    methodName: 'getRecurringPaymentMethods',
    service: PaymentsServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
      serializeBinary() {
        return GetRecurringPaymentMethodsRequest.encode(this).finish();
      },
    } as any,
    responseType: {
      deserializeBinary(data: Uint8Array) {
        return {
          ...GetRecurringPaymentMethodsResponse.decode(data),
          toObject() {
            return this;
          },
        };
      },
    } as any,
  };

export const PaymentsServiceupdateRecurringPaymentInfoDesc: UnaryMethodDefinitionish =
  {
    methodName: 'updateRecurringPaymentInfo',
    service: PaymentsServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
      serializeBinary() {
        return UpdateRecurringPaymentMethodRequest.encode(this).finish();
      },
    } as any,
    responseType: {
      deserializeBinary(data: Uint8Array) {
        return {
          ...UpdateRecurringPaymentMethodResponse.decode(data),
          toObject() {
            return this;
          },
        };
      },
    } as any,
  };

export const PaymentsServicedeleteRecurringPaymentDesc: UnaryMethodDefinitionish =
  {
    methodName: 'deleteRecurringPayment',
    service: PaymentsServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
      serializeBinary() {
        return DeleteRecurringPaymentRequest.encode(this).finish();
      },
    } as any,
    responseType: {
      deserializeBinary(data: Uint8Array) {
        return {
          ...DeleteRecurringPaymentResponse.decode(data),
          toObject() {
            return this;
          },
        };
      },
    } as any,
  };

export const PaymentsServicecreateRecurringPaymentMethodDesc: UnaryMethodDefinitionish =
  {
    methodName: 'createRecurringPaymentMethod',
    service: PaymentsServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
      serializeBinary() {
        return CreateRecurringPaymentMethodRequest.encode(this).finish();
      },
    } as any,
    responseType: {
      deserializeBinary(data: Uint8Array) {
        return {
          ...CreateRecurringPaymentMethodResponse.decode(data),
          toObject() {
            return this;
          },
        };
      },
    } as any,
  };

export const PaymentsServicesetRefundBankAccountDesc: UnaryMethodDefinitionish =
  {
    methodName: 'setRefundBankAccount',
    service: PaymentsServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
      serializeBinary() {
        return SetRefundBankAccountRequest.encode(this).finish();
      },
    } as any,
    responseType: {
      deserializeBinary(data: Uint8Array) {
        return {
          ...SetRefundBankAccountResponse.decode(data),
          toObject() {
            return this;
          },
        };
      },
    } as any,
  };

export const PaymentsServicecreateGiftCardRefundDesc: UnaryMethodDefinitionish =
  {
    methodName: 'createGiftCardRefund',
    service: PaymentsServiceDesc,
    requestStream: false,
    responseStream: false,
    requestType: {
      serializeBinary() {
        return CreateGiftCardRefundRequest.encode(this).finish();
      },
    } as any,
    responseType: {
      deserializeBinary(data: Uint8Array) {
        return {
          ...CreateGiftCardRefundResponse.decode(data),
          toObject() {
            return this;
          },
        };
      },
    } as any,
  };

interface UnaryMethodDefinitionishR extends UnaryMethodDefinition<any, any> {
  requestStream: any;
  responseStream: any;
}

type UnaryMethodDefinitionish = UnaryMethodDefinitionishR;

interface Rpc {
  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any>;
}

export class GrpcWebImpl {
  private host: string;
  private options: {
    transport?: grpc.TransportFactory;

    debug?: boolean;
    metadata?: grpc.Metadata;
  };

  constructor(
    host: string,
    options: {
      transport?: grpc.TransportFactory;

      debug?: boolean;
      metadata?: grpc.Metadata;
    },
  ) {
    this.host = host;
    this.options = options;
  }

  unary<T extends UnaryMethodDefinitionish>(
    methodDesc: T,
    _request: any,
    metadata: grpc.Metadata | undefined,
  ): Promise<any> {
    const request = {..._request, ...methodDesc.requestType};
    const maybeCombinedMetadata =
      metadata && this.options.metadata
        ? new BrowserHeaders({
            ...this.options?.metadata.headersMap,
            ...metadata?.headersMap,
          })
        : metadata || this.options.metadata;
    return new Promise((resolve, reject) => {
      grpc.unary(methodDesc, {
        request,
        host: this.host,
        metadata: maybeCombinedMetadata,
        transport: this.options.transport,
        debug: this.options.debug,
        onEnd: function (response) {
          if (response.status === grpc.Code.OK) {
            resolve(response.message);
          } else {
            const err = new Error(response.statusMessage) as any;
            err.code = response.status;
            err.metadata = response.trailers;
            reject(err);
          }
        },
      });
    });
  }
}

type Builtin = Date | Function | Uint8Array | string | number | undefined;
export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {$case: string}
  ? {[K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]>} & {$case: T['$case']}
  : T extends {}
  ? {[K in keyof T]?: DeepPartial<T[K]>}
  : Partial<T>;
